<div class="modal-header d-flex justify-content-center justify-content-between">
    <div>
      <h4 class="modal-title" id="modal-basic-title">{{mobileInstructionDetails.name}}
        <i *ngIf="!hideExportButton && lgScreenShot.path" class="fas fa-file-export clickable ml-1 mb-2" ngbTooltip="Save Image to File Management"  (click)="exportImage(lgScreenShot)"></i>
      </h4>
    </div>
    <div class="d-flex align-items-center mt-2" >
      <div *ngIf="lgScreenShot.path">
        <i class="fas fa-download clickable mx-2" ngbTooltip="Download Image"  (click)="downloadFile()"></i>
      </div>
      <div>
        <i class="fa fa-times clickable mx-2" ngbTooltip="Close" aria-hidden="true"  (click)="activeModal.dismiss('Cross click')"></i>
    </div>
    </div>
     

  </div>
  <div class="modal-body text-center" >
    <div class="loader" *ngIf="!lgScreenShot.path"></div>
        <img class="img-fluid" [attr.src]="lgScreenShot.path"  />
  </div>
